/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function displayLogo () {
    console.log(`%c
 (((((
(((((((((
((((((((((((
(((((((((((((((
((((((((((((((((((
((((((((((((((((((((((
(((((((((((((((((((((((((
((((((((((((       (((((((((
(((((((((((         (((((((((((
((((((((((           (((((((((((((
(((((((((((         (((((((((((((((((
(((((((((((((             (((((((((((((
((((((((((((((                 ((((((((
((((((((((((                      (((((
(((   (((((               ((((((
((((%          ((          (((((((
((((((((     ((((((         (((
((((((((((((((((((
((((((((((((((((
((((((((((((((
((((((((((((
(((((((((((
((((((((((
(((((((((
 (((((

${atob('TG9va2luZyBmb3Igc29tZXRoaW5nPyB1c2UgU09VUkNFMTUgYXQgY2hlY2tvdXQgZm9yIDE1JSBvZmYu')}`, "font-family:monospace");
}
displayLogo();

(function ( $ ) {
    //controllers for ecom go here - see gatewayControl.js for examples
    plae = window.plae || {};
    plae.history = _.extend(plae.history || {} , {
        count: 0
    });
    $(window).on("popstate", function(e) {
        plae.history.count--;
    });
    plae.map = {
        "base_media": "https://cdn.shopify.com/s/files/1/0406/7793/3205/files/",
        "swatches" : "",
        "product" : ""
    };
    plae.analytics = _.extend(plae.analytics || {}, {
        debug: false,
        init: function(callback) {
            if(callback) callback();
        },
        isGAenabled: function() {
            return window.ga && ga.loaded;
        },
        trackEvent: function(category, action, label, value, noninteraction, callback) {
            var fields = noninteraction ? {"noninteraction":noninteraction} : {};
            if (plae.analytics.isGAenabled()) {
                ga('send', 'event', category, action, label, value, fields);
            }

            if (plae.analytics.debug) {
                console.dir(category);
            }
            if(callback) callback();
        },
        trackPageView: function(callback) {
            if (plae.analytics.isGAenabled()) {
                ga('send', 'pageview', location.pathname);
            }
            if (plae.analytics.debug) {
                console.dir(location.pathname);
            }
            if(callback) callback();
        },
        trackScreenView: function(screenname, callback) {
            var fields = {"screenname":screenname};
            if (plae.analytics.isGAenabled()) {
                ga('send', 'screenview', fields);
            }
            if(callback) callback();
        },
        trackException: function(description, fatal, callback) {
            var fields = {"exDescription":description, "exFatal":fatal};
            if (plae.analytics.isGAenabled()) {
                ga('send', 'exception', fields);
            }
            if(callback) callback();
        },
        fbq: window.fbq || function() {
        },
        setCustomer: function(id) {
            if (plae.analytics.debug) {
                console.dir(id);
            }
        },
        setDebug: function(enabled) {
            plae.analytics.debug = enabled;
        }
    });
    plae.analytics.init();

    plae.graphql = _.extend(plae.graphql || {}, {
        query: function (input, success, error){
            var graphqlpath = '/api/2019-10/graphql.json';

            /**
             * This query needs to be executed prior to fetch. We need to expose the metafield first.
             *  mutation($input: MetafieldStorefrontVisibilityInput!) {
                        metafieldStorefrontVisibilityCreate( input: $input ) {
                            metafieldStorefrontVisibility {
                                id
                            }
                            userErrors {
                                field message
                            }
                        }
                    }

             Using the Query Variables:
             {
                      "input": {
                        "namespace": "collection_discount",
                        "key": "ty-atc",
                        "ownerType": "PRODUCT"
                      }
                    }
             */

            (function(){
                fetch(graphqlpath, {
                    method: 'post',
                    headers: {
                        'X-Shopify-Storefront-Access-Token': plae.graphql.accesstoken, // private app storefront access token
                        'Accept': 'application/graphql',
                        'Content-Type': 'application/json' },
                    body: JSON.stringify({ query: input })
                })
                    .then(function(response) {
                        return response.json();
                    }).then(function(data) {
                    success(data);
                })
                    .catch(function (err) {
                        error(err);
                    });
            })(success, error);
        }
    });

    plae.controllers = _.extend(plae.controllers || {}, {
    	init: function(){
    	  plae.controllers.cart.init();
          plae.controllers.helper.waitForElementToDisplay('.__seguno-banner-text', 500, function() {
              jQuery('.__seguno-banner-text').on('click', function() {
                  plae.analytics.trackEvent("click","banner", "banner-click");
              });
          });
		},
        helper: {
            updateURL: function (pathname, search, hash, data, title, usePush) {
                var pathname = pathname || location.pathname || '';
                search = search ? (search.indexOf('?') > -1 ? search : '?' + search) : search != '' ? location.search : '';
                hash = hash ? (hash.indexOf('#') > -1 ? hash : '#' + hash) : (location.hash != '' ? location.hash : '');
                data = data || {};
                title = title || "plae";
                if (usePush) {
                    window.history.pushState(data, title, pathname + search + hash);
                    plae.history.count++;
                }
                else {
                    window.history.replaceState(data, title, pathname + search + hash);
                }
            },
            getUrlParameters: function (name, url) {
                if (!url) url = window.location.href;
                if (typeof name != 'undefined' && name != null) {
                    name = name.replace(/[\[\]]/g, "\\$&");
                    var regex = new RegExp("[#?&]" + name + "(=([^&#]*)|&|$)"),
                        results = regex.exec(url);
                    if (!results) return null;
                    if (!results[2]) return '';
                    return decodeURIComponent(results[2].replace(/\+/g, " "));
                }
                else {
                    var str = url.split('#')[1];
                    var data = {};
                    if (str) {
                        var pieces = str.split("&"), i, parts;
                        // process each query pair
                        for (i = 0; i < pieces.length; i++) {
                            parts = pieces[i].split("=");
                            if (parts.length < 2) {
                                parts.push("");
                            }
                            if (parts[0] !== "") {
                                data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                            }
                        }
                    }
                    return data;
                }
            },
            replaceAt: function (string, index, replace) {
                return string.substring(0, index) + replace + string.substring(index + 1);
            },
            addModalOverlay: function(modal) {
                var $overlay = $('.ModalOverlay');
                if ($overlay.length > 0) {
                    $overlay.addClass('is-visible');
                    $overlay.on('click', function(e) {
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        $(modal).children()[0].click();
                    });
                }
            },
            waitForElementToDisplay: function(selector, time, callback) {
                if(document.querySelector(selector)!=null) {
                    if (callback) callback();
                    return;
                }
                else {
                    setTimeout(function() {
                        plae.controllers.helper.waitForElementToDisplay(selector, time, callback);
                    }, time);
                }
            }
        },
        mask: {
            showFullMask: function() {
                $('#fullmask').removeClass('hide fade');
            },
            hideFullMask: function() {
                $('#fullmask').addClass('fade');
                $('.PageOverlay').removeClass("is-visible");
            }
        }
    });
    jQuery(document).ready(function() {
        plae.controllers.init();
    });
}( jQuery ));